<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div v-if="exportLoading">
              Loading. . .
            </div>
            <div v-else>
              <b-button size="sm" variant="primary" v-b-modal.modal-donasi @click="exportUser">Export</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Data Table</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-show="isFetched">
              <div class="table-responsive mb-0">
                <vue-good-table
                    mode="remote"
                    :pagination-options="{
                      enabled: false,
                      mode: 'pages',
                      perPage: perPage,
                      position: 'bottom',
                      perPageDropdown: [5, 10],
                      dropdownAllowAll: false,
                      nextLabel: 'next',
                      prevLabel: 'prev',
                      rowsPerPageLabel: 'Rows per page',
                      ofLabel: 'of',
                      pageLabel: 'page', // for 'pages' mode
                      allLabel: 'All',
                    }"
                    :totalRows="totalRows"
                    :rows="accountData"
                    :columns="columns"
                    :sort-options="{
                      enabled: false,
                    }"
                    :row-style-class="rowStyleClassFn"
                >
                  <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'status'">
                      <span v-if="props.row.membership_expired_date == 'None'">Free</span>
                      <span v-else> {{props.row.membership_product_name}} sampai {{ props.row.membership_expired_date }} </span>
                    </div>
                  </template>
                </vue-good-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
export default {
  name: "account",
  page: {
    title: "Account",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader},
  created() {
    this.fetchAccountData()
  },
  data() {
    return {
      title: "Account",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      searchText: '',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      isFetched: false,
      getArguments: {
        limit: 11,
        page: 1,
        sort: '-id',
        name: '',
      },
      accountData: [],
      columns: [
        { field: "name", label: "Nama" },
        { field: "email", label: "Email" },
        { field: "provinsi_name", label: "Kota" },
        { field: "institution_name", label: "Institusi" },
        { field: "status", label: "Status" },
        { field: "last_login", label: "Last Login" },
        { field: "lesson_plan", label: "Jumlah RPP" },
        { field: "silabus", label: "Jumlah Silabus" },
        { field: "strategi", label: "Jumlah Strategi" },
        { field: "rubrik", label: "Jumlah Rubrik" },
        { field: "penilaian", label: "Jumlah Penilaian" },
        { field: "prota", label: "Jumlah Prota" },
        { field: "prosem", label: "Jumlah Prosem" },
        { field: "referral", label: "Referral"}
      ],
      exportLoading: false,
    }
  },
  computed: {


  },
  methods: {
    rowStyleClassFn() {
      return 'default'
    },
    fetchAccountData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallAccountData(params)
    },
    httpCallAccountData(params) {
      axios.get("/api/account/dashboard-report?"+params)
          .then(resp => {
            const { data, pagination } = resp.data
            this.totalRows = pagination.total
            this.accountData = data
            this.isFetched = true
          });
    },
    exportUser() {
      this.exportLoading = true
      axios.get("/api/account/report/export")
          .then(resp => {
            const { data } = resp.data
            var temp = 'data:application/vnd.ms-excel;base64,'
                +encodeURIComponent(data);
            var download = document.createElement('a');
            download.href = temp;
            download.download = 'user-export.xlsx';
            document.body.appendChild(download);
            download.click();
            document.body.removeChild(download);
            this.exportLoading = false
          });
    }
  },
  watch: {
    searchText: function(value){
      this.currentPage = 1
      let params = queryString.stringify({
        limit: this.perPage,
        page: this.currentPage,
        name: value,
        sort: '-id',
      })
      this.httpCallAccountData(params)
    },
    perPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1
        let params = queryString.stringify({
          limit: newValue,
          page: this.currentPage,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
    currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = queryString.stringify({
          limit: this.perPage,
          page: newValue,
          name: this.searchText,
          sort: '-id',
        })
        this.httpCallAccountData(params)
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>